
import { useEffect, useState } from "react"
import Card from "../Card"
import FunFact from "../FunFact"
import Hero from "../Hero"
import Div from "../Div"
import SectionHeading from "../SectionHeading"
import Spacing from "../Spacing"
import Cta from "../Cta"
import LogoList from "../LogoList"
import MovingText from "../MovingText"
import PortfolioSlider from "../Slider/PortfolioSlider"
import TestimonialSlider from "../Slider/TestimonialSlider"
import TeamSlider from "../Slider/TeamSlider"
import TimelineSlider from "../Slider/TimelineSlider"
import { pageTitle } from "../../helper"
import PostSlider from '../Slider/PostSlider';

// Hero Social Links
const heroSocialLinks = [
  {
    name: "Instagram",
    links: "https://www.instagram.com/justchargemedia/",
  },
  {
    name: "LinkedIn",
    links: "https://www.linkedin.com/company/justchargemedia/posts/?feedView=all",
  },
]

// FunFact Data
const funfaceData = [
  {
    title: 'Brands Transformed',
    factNumber: '100',
  },
  {
    title: 'Creative Minds Fueling Innovation',
    factNumber: '20',
  },
  {
    title: 'Projects Crafted to Perfection',
    factNumber: '200',
  },
  {
    title: 'Digital Products Shaping the Future',
    factNumber: '50',
  },
];
const portfolioData = [
  {
    title: "Angsa",
    subtitle: "Stitched moments - raw, rooted, resplendent",
    // href: "/portfolio",
    src: "https://res.cloudinary.com/djgqvtvkz/image/upload/v1744443159/bdcowqxhggn8flgmnpgd.jpg",
  },
  {
    title: "Mr.Button",
    subtitle: "Crafted Mr. Button — tailored, tonal, effortlessly luxe.",
    // href: "/portfolio",
    src: "https://res.cloudinary.com/djgqvtvkz/image/upload/v1744443163/hudp0xcphehvyafsfcss.jpg",
  },
  {
    title: "Panash",
    subtitle: "Glazed Panash — juicy, bold, love-soaked.",
    // href: "/portfolio",
    src: "https://res.cloudinary.com/djgqvtvkz/image/upload/v1744443160/cu6wzueo1nheync9gxu5.png",
  },
  {
    title: "Onsara",
    subtitle: "Bloomed Onsara — soft, floral, rooted.",
    // href: "/portfolio",
    src: "https://res.cloudinary.com/djgqvtvkz/image/upload/v1744443163/wfpgfwpugjnzfksfthfa.png",
  },
]

// Creator Connect Popup Component
const CreatorConnectPopup = ({ isOpen, onClose }) => {
  const [representationType, setRepresentationType] = useState("")
  const [fullName, setFullName] = useState("")
  const [email, setEmail] = useState("")
  const [contactNumber, setContactNumber] = useState("")
  const [sending, setSending] = useState(false)
  const [sendStatus, setSendStatus] = useState(null)

  if (!isOpen) return null

  const handleSubmit = async (e) => {
    e.preventDefault()
    // Set sending state to show loading indicator
    setSending(true)
    setSendStatus(null)

    // Format the message to include all form information
    const formattedMessage = `Representation Type: ${representationType}\nName: ${fullName}\nEmail: ${email}\nContact: ${contactNumber}`;

    try {
      // Replace with your WhatsApp number
      const whatsappUrl = `https://wa.me/+919501412704?text=${encodeURIComponent(formattedMessage)}`;
      window.open(whatsappUrl, "_blank");

      // Update status and reset form
      setSendStatus("success");
      console.log({ representationType, fullName, email, contactNumber });

      // Reset form fields after successful submission
      setRepresentationType("");
      setFullName("");
      setEmail("");
      setContactNumber("");

      // Close the popup
      onClose();
    } catch (error) {
      console.error("Error sending message:", error);
      setSendStatus("error");
    } finally {
      setSending(false);
    }
  }

  // Internal CSS styles
  const popupStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.7)",
      backdropFilter: "blur(5px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 999,
    },
    container: {
      backgroundColor: "#111",
      borderRadius: "5px",
      width: "90%",
      maxWidth: "500px",
      position: "relative",
      padding: "30px",
      color: "white",
      border: "1px solid #333",
    },
    close: {
      position: "absolute",
      top: "15px",
      right: "15px",
      cursor: "pointer",
      color: "#f9a94e",
    },
    title: {
      fontSize: "24px",
      fontWeight: "bold",
      marginBottom: "20px",
      color: "#f9a94e",
    },
    formGroup: {
      marginBottom: "20px",
    },
    label: {
      display: "block",
      marginBottom: "8px",
      fontWeight: "500",
    },
    select: {
      width: "100%",
      padding: "10px",
      marginBottom: "15px",
      backgroundColor: "#222",
      border: "1px solid #333",
      borderRadius: "4px",
      color: "white",
      appearance: "none",
      backgroundImage:
        'url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23f9a94e%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E")',
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 10px top 50%",
      backgroundSize: "12px auto",
      paddingRight: "30px",
    },
    input: {
      width: "100%",
      padding: "10px",
      marginBottom: "15px",
      backgroundColor: "#222",
      border: "1px solid #333",
      borderRadius: "4px",
      color: "white",
    },
    button: {
      backgroundColor: "#f9a94e",
      color: "black",
      border: "none",
      padding: "12px 24px",
      borderRadius: "4px",
      fontWeight: "bold",
      cursor: "pointer",
      display: "inline-block",
      transition: "background-color 0.3s",
    },
    buttonHover: {
      backgroundColor: "#e89a3e",
    },
    statusMessage: {
      marginTop: "15px",
      padding: "10px",
      borderRadius: "4px",
      textAlign: "center",
    },
    success: {
      backgroundColor: "rgba(0, 128, 0, 0.2)",
      color: "#4ade80",
    },
    error: {
      backgroundColor: "rgba(255, 0, 0, 0.2)",
      color: "#f87171",
    }
  }

  return (
    <div style={popupStyles.overlay} onClick={onClose}>
      <div style={popupStyles.container} onClick={(e) => e.stopPropagation()}>
        <div style={popupStyles.close} onClick={onClose}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M1 1L19 19M19 1L1 19"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div>
          <h2 style={popupStyles.title}>Let's Build the Future Together!</h2>
        </div>
        <div>
          <form onSubmit={handleSubmit}>
            <div style={popupStyles.formGroup}>
              <label style={popupStyles.label}>I am representing:</label>
              <select
                style={popupStyles.select}
                value={representationType}
                onChange={(e) => setRepresentationType(e.target.value)}
                required
              >
                <option value="">Select an option</option>
                <option value="brand">A Brand</option>
                <option value="agency">An Agency</option>
                <option value="influencer">An Influencer</option>
              </select>
            </div>
            <div style={popupStyles.formGroup}>
              <label style={popupStyles.label}>Full Name</label>
              <input
                type="text"
                style={popupStyles.input}
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                required
              />
            </div>
            <div style={popupStyles.formGroup}>
              <label style={popupStyles.label}>Email</label>
              <input
                type="email"
                style={popupStyles.input}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div style={popupStyles.formGroup}>
              <label style={popupStyles.label}>Contact Number</label>
              <input
                type="tel"
                style={popupStyles.input}
                value={contactNumber}
                onChange={(e) => setContactNumber(e.target.value)}
                required
              />
            </div>
            <button
              type="submit"
              style={{
                ...popupStyles.button,
                opacity: sending ? 0.7 : 1,
                cursor: sending ? "not-allowed" : "pointer"
              }}
              onMouseOver={(e) => !sending && (e.currentTarget.style.backgroundColor = "#e89a3e")}
              onMouseOut={(e) => !sending && (e.currentTarget.style.backgroundColor = "#f9a94e")}
              disabled={sending}
            >
              {sending ? "Sending..." : "Send"}
            </button>

            {sendStatus && (
              <div
                style={{
                  ...popupStyles.statusMessage,
                  ...(sendStatus === "success" ? popupStyles.success : popupStyles.error)
                }}
              >
                {sendStatus === "success"
                  ? "Message sent successfully! Redirecting to WhatsApp..."
                  : "Failed to send message. Please try again."}
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  )
}

export default function Home() {
  pageTitle("Home")
  const [isPopupOpen, setIsPopupOpen] = useState(false)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      {/* Start Hero Section */}
      <Hero
        title="Creativity In <br/>Our Blood Line"
        subtitle="Revolutionising Challenges Into Seamless Solutions, Crafted With Creativity, Delivered With Perfection.
"
        btnText="Let's Create Magic Together"
        btnLink="/contact"
        scrollDownId="#service"
        socialLinksHeading="Follow Us"
        heroSocialLinks={heroSocialLinks}
        bgImageUrl="/images/hero_bg.jpeg"
      />
      {/* End Hero Section */}

      {/* Start FunFact Section */}
      <div className="container">
        <FunFact
          variant="cs-type1"
          title="Our Creative Code"
          subtitle="Creativity isn't just what we do, it's who we are. We decode challenges, engineer innovations, and craft future-ready solutions that transform ideas into impact. "
          data={funfaceData}
        />
      </div>
      {/* End FunFact Section */}

      {/* Start Service Section */}
      <Spacing lg="150" md="80" />
      <Div id="service">
        <Div className="container">
          <Div className="row">
            <Div className="col-xl-4">
              <SectionHeading
                title="Solutions Tailored for You 
"
                subtitle="The Magic We Deliver "
                btnText="Explore All Services"
                btnLink="/service"
              />
              <Spacing lg="90" md="45" />
            </Div>
            <Div className="col-xl-8">
              <Div className="row">
                <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
                <Div className="col-lg-3 col-sm-6">
                  <Card
                    title="Designing Experiences"
                    link="/designing-experiences"
                    src="/images/service_3.png"
                    alt="Service"
                  />
                  <Spacing lg="0" md="30" />
                </Div>
                <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
                <Div className="col-lg-3 col-sm-6">
                  <Card
                    title="Creating Content"
                    link="/creatingcontent"
                    src="/images/service_2.png"
                    alt="Service"
                  />
                  <Spacing lg="0" md="30" />
                </Div>
                <Div className="col-lg-3 col-sm-6">
                  <Card
                    title="Crafting Brands"
                    link="/crafting-brands"
                    src="/images/service_1.png"
                    alt="Service"
                  />
                  <Spacing lg="0" md="30" />
                </Div>
                <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
                <Div className="col-lg-3 col-sm-6">
                  <Card
                    title="Building Tech"
                    link="/BuildingTech"
                    src="/images/service_4.jpeg"
                    alt="Service"
                  />
                  <Spacing lg="0" md="30" />
                </Div>
                <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
              </Div>
            </Div>
          </Div>
        </Div>
      </Div>
      {/* End Service Section */}

      {/* Start Portfolio Section */}
      <Spacing lg="150" md="50" />
      <Div>
        <Div className="container">
          <SectionHeading
            title="Explore Our Portfolio"
            subtitle="Our Latest Creations"
            variant="cs-style1 text-center"
          />
          <Spacing lg="90" md="45" />
        </Div>
        <PortfolioSlider data={portfolioData} />
      </Div>
      {/* End Portfolio Section */}

      {/* Start Awards Section */}
      {/* <Spacing lg="150" md="80" />
      <Div className="cs-shape_wrap_2">
        <Div className="cs-shape_2">
          <Div />
        </Div>
        <Div className="container">
          <Div className="row">
            <Div className="col-xl-4">
              <SectionHeading title="Creators Connect <br/>Delhi Edition" subtitle="Powered by Us!" variant="cs-style1" />
              <Spacing lg="30" md="20" />
              <Div className="text-left">
                <button className="cs-btn cs-style1" onClick={() => setIsPopupOpen(true)}>
                  <span>Let’s Build The Future Together!</span>
                </button>
              </Div>
              <Spacing lg="60" md="25" />
            </Div>
            <Div className="col-xl-7 offset-xl-1">
              <TimelineSlider />
            </Div>
          </Div>
        </Div>
      </Div> */}
      {/* End Awards Section */}



      {/* Start Blog Section */}
      <Spacing lg="150" md="80" />
      <Div className="cs-shape_wrap_4">
        <Div className="cs-shape_4"></Div>
        <Div className="cs-shape_4"></Div>
        <Div className="container">
          <Div className="row">
            <Div className="col-xl-4">
              <SectionHeading
                title="Creators Connect <br/>Delhi Edition"
                subtitle="Powered By Us"
              />
              <button className="cs-btn cs-style1" onClick={() => setIsPopupOpen(true)}>
                <span>Let’s Build The Future Together!</span>
              </button>
              <Spacing lg="90" md="45" />
            </Div>
            <Div className="col-xl-7 offset-xl-1">
              <Div className="cs-half_of_full_width">
                <PostSlider />
              </Div>
            </Div>
          </Div>
        </Div>
      </Div>
      {/* End Blog Section */}

      {/* Start Video Block Section */}
      <Spacing lg="130" md="70" />
      <Div className="container">
        <h2 className="cs-font_50 cs-m0 text-center cs-line_height_4">
          Great Brands Aren't Found, They're Built.<br /> Let's Craft, Innovate, And
          Scale Your Vision Into Reality!
        </h2>
        {/* <Spacing lg="70" md="70" />
        <VideoModal
          videoSrc="https://www.youtube.com/watch?v=VcaAVWtP48A"
          bgUrl="/images/video_bg.jpeg"
        /> */}
      </Div>
      {/* End Video Block Section */}

      {/* Start Team Section */}
      <Spacing lg="145" md="80" />
      <Div className="container">
        <SectionHeading
          title="Meet Our Rockstars"
          subtitle="Creators, Innovators & Game-Changers "
          variant="cs-style1"
        />
        <Spacing lg="85" md="45" />
        <TeamSlider />
      </Div>
      <Spacing lg="150" md="80" />
      {/* End Team Section */}

      {/* Start Testimonial Section */}
      <TestimonialSlider />
      {/* End Testimonial Section */}



      {/* Start MovingText Section */}
      <Spacing lg="105" md="70" />
      <MovingText text="Global Brands, Powerful Partnerships, Lasting Impact" />
      <Spacing lg="105" md="70" />
      {/* End MovingText Section */}

      {/* Start LogoList Section */}
      <Div className="container">
        <LogoList />
      </Div>
      <Spacing lg="150" md="80" />
      {/* End LogoList Section */}

      {/* Start CTA Section */}
      <Div className="container">
        <Cta
          title="Let&apos;s Build The <br />Next Big Thing Together! "
          btnText="Your Next Big Move Starts Here!"
          btnLink="/contact"
          bgSrc="/images/cta_bg.jpeg"
        />
      </Div>
      {/* End CTA Section */}

      {/* Creators Connect Popup */}
      <CreatorConnectPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </>
  )
}

